let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1671622162322x532070389766160400',
        data: '2023, June 7',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "For Junior specialists",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1671622030643x369455782015533060',
        data: '2023, June 6',
    },
];

export default PackagesItem;
